import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useThemes } from './hooks/useThemes'
import { ThemeEditorPage } from './pages/ThemeEditorPage'
import { CreateThemePage } from './pages/CreateThemePage'
import { FavoritesProvider, useFavoritesContext } from '../shared/FavoritesContext'
import ToolNav from '../shared/ToolNav'

function AppContent() {
  const {
    themes,
    activeThemeId,
    prefersDarkMode,
    createTheme,
    deleteTheme,
    updateTheme,
    setActiveTheme,
    toggleDarkMode,
    duplicateTheme,
    exportTheme,
    importTheme,
    getThemeBySlug,
  } = useThemes()

  const { isPairingFavorited, isPairingSortFavorited, togglePairing, isFontFavorited, isFontSortFavorited, toggleFont, authenticated, pairingSortSnapshot, fontSortSnapshot } = useFavoritesContext()

  return (
    <>
      <ToolNav current="/themes" />
      <Routes>
        <Route
          path="/themes/new"
          element={
            <CreateThemePage
              onCreate={createTheme}
              isPairingFavorited={isPairingFavorited}
              isPairingSortFavorited={isPairingSortFavorited}
              togglePairing={togglePairing}
              isFontFavorited={isFontFavorited}
              isFontSortFavorited={isFontSortFavorited}
              toggleFont={toggleFont}
              authenticated={authenticated}
              pairingSortSnapshot={pairingSortSnapshot}
              fontSortSnapshot={fontSortSnapshot}
            />
          }
        />
        <Route
          path="/themes/:themeSlug/edit"
          element={
            <ThemeEditorPage
              themes={themes}
              activeThemeId={activeThemeId}
              prefersDarkMode={prefersDarkMode}
              getThemeBySlug={getThemeBySlug}
              setActiveTheme={setActiveTheme}
              updateTheme={updateTheme}
              deleteTheme={deleteTheme}
              duplicateTheme={duplicateTheme}
              exportTheme={exportTheme}
              importTheme={importTheme}
              toggleDarkMode={toggleDarkMode}
            />
          }
        />
        <Route path="*" element={<Navigate to="/themes" replace />} />
      </Routes>
    </>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <FavoritesProvider rootElementId="themes">
        <AppContent />
      </FavoritesProvider>
    </BrowserRouter>
  )
}
